<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row >
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t('shortcutMenu') }}</h1>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end gap-2">
                  <div class="custom-search-input-wrapper">
                    <div class="custom-search-input-container">
                      <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                      <input id="shortcut-commands-field-search-modelshortcut-commands" type="text" :placeholder="$t('shortcutGroupName')"
                        :aria-label="$t('shortcutGroupName')" class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                      <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                        @click="searchName = ''">
                        mdi-close-circle
                      </v-icon>
                    </div>
                  </div>
              <v-btn
                id="button-add-popupadd-modelshortcut-commands"
                class="control-btn create-btn customadd"
                variant="flat"
                size="large"
                prepend-icon="mdi-plus"
                rounded="xl"
                @click="Add()"
              >
              {{ $t("add") }}
              <v-tooltip activator="parent" location="top">{{ $t('addShortcutMenu') }}</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :items="menus"
          :headers="headers"
          :loading="loadingTable"
          class="pa-5"
        >
          <template v-slot:item="{ item,index }">
            <tr>
              <td style="text-align: center">{{ (options.page - 1) * options.itemsPerPage + index + 1 }}</td>
              <td>{{ item.nameDisplay }}</td>
              <td style="text-align: left">
                {{ item.listCommand }}
              </td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-modelshortcut-commands"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-img :src="images.editBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t("edit") }}
                    </v-tooltip>
                  </v-btn>                
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupdelete-modelshortcut-commands"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item.shortcutMenuGroupID)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t("delete") }}
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <!-- 👇 Custom footer area -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Loading Please Wait... -->
    <LoadingOverlay :model-value="loading" />
    <!-- Edit -->
    <v-dialog v-model="shortcutMenuDialog" max-width="900px" persistent scrollable class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">{{ Adddialog ? $t('addShortcutMenu') : $t('editShortcutMenu') }}</h2>
                <v-chip
                  v-if="Shortcutmenu.listShortcuts && Shortcutmenu.listShortcuts.length > 0"
                  size="small"
                  variant="tonal"
                  color="primary"
                  class="summary-chip"
                >
                  {{ $t('_commandsConfigured', { count: Shortcutmenu.listShortcuts.length }) }}
                </v-chip>
              </div>
              <p class="dialog-subtitle">{{ Adddialog ? $t('_createShortcutMenu') : $t('_modifyShortcutMenuConfig') }}</p>
            </div>
          </div>
        </div>
        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex"> <v-img :src="images.basicInfo" width="20" height="20" class="mr-5"></v-img> {{ $t('basicInformation') }}</h3>
              </div>
              
              <v-row>
                <v-col cols="12">
                  <div class="input-wrapper">
                    <div class="input-label">
                      <span>{{ $t('shortcutCommandsGroupName') }}</span>
                      <span class="required-asterisk">*</span>
                      <InfoTooltip :text="$t('_shortcutGroupNameTooltip')"
                        size="small" color="grey-darken-1" icon-class="help-icon help-icon-accent" location="top" max-width="300px" />
                    </div>
                    
                    <v-text-field
                      :id="Adddialog ? 'shortcut-commands-groupname-field-popupadd-modelshortcut-commands' : 'shortcut-commandsgroupname-field-popupedit-modelshortcut-commands'"
                      v-model="Shortcutmenu.groupName"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="comfortable"
                      :placeholder="$t('_enterGroupName')"
                      hide-details="auto"
                      class="modern-input"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="form-container mt-5">
            
            <!-- Shortcut Commands Section -->
            <div class="form-section">
              <div class="section-header">  
                <h3 class="section-title d-flex"> <v-img :src="images.chatInfo" width="20" height="20" class="mr-2"></v-img>{{ $t("ShortcutCommands") }}</h3>
                <InfoTooltip :text="$t('_configureShortcutCommands')"
                  size="small" icon-class="help-icon help-icon-accent" location="top" max-width="300px" />
                <v-chip
                  v-if="Shortcutmenu.listShortcuts && Shortcutmenu.listShortcuts.length > 0"
                  size="small"
                  variant="tonal"
                  color="info"
                  class="summary-chip"
                >
                  {{ Shortcutmenu.listShortcuts.length }} {{ $t(Shortcutmenu.listShortcuts.length === 1 ? 'command' : 'commands') }}
                </v-chip>
              </div>
              <!-- Shortcut Commands Table -->
              <div class="table-container">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th scope="col" class="table-header">#</th>
                      <th scope="col" class="table-header label-col">{{ $t("Label") }}
                        <InfoTooltip :text="$t('_shortcutCommandsName')"
                          size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                      </th>
                      <th scope="col" class="table-header label-col">{{ $t("Message") }}
                        <InfoTooltip :text="$t('_shortcutCommandsDataSent')"
                          size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                      </th>
                      <th scope="col" class="table-header" style="text-align: center;">{{ $t("UploadImage") }}
                        <InfoTooltip :text="$t('_selectIconForShortcut')"
                          size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                      </th>
                      <th scope="col" class="table-header" style="text-align: center;">{{ $t("IconPreview") }}</th>
                      <th scope="col" class="table-header actions-col" style="text-align: center;">{{ $t("manage")}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in Shortcutmenu.listShortcuts"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell">
                        <v-text-field
                          :id="(Adddialog ? 'label-field-popupadd-modelshortcut-commands-' : 'label-field-popupedit-modelshortcut-commands-') + index"
                          v-model="item.nameDisplay"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          :placeholder="Adddialog ? $t('_enterLabel') : $t('_quickReplyName')"
                        >
                        </v-text-field>
                      </td>
                      
                      <td class="table-cell">
                        <v-text-field
                          :id="(Adddialog ? 'message-field-popupadd-modelshortcut-commands-' : 'message-field-popupedit-modelshortcut-commands-') + index"
                          v-model="item.command"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          :placeholder="Adddialog ? $t('_enterMessage') : $t('_quickReplyData')"
                        >
                        </v-text-field>
                      </td>
                      
                      <td class="table-cell upload-cell">
                        <v-btn
                          :id="'button-upload-popupadd-modelshortcut-commands-' + index"
                          color="#C32E0E"
                          variant="outlined"
                          size="small"
                          class="upload-btn"
                          @click="Click_FileButtonShortcutMenu(index)"
                        >
                          <v-img :src="images.iconcolImg" class="mr-2" width="16" height="16" alt="Upload"></v-img>
                          {{ $t("UploadImage") }}
                          <v-tooltip v-if="item.imageURL && item.imageURL !== ''" activator="parent" location="top">
                              {{ $t('changeIcon') }}
                          </v-tooltip>
                          <v-tooltip v-else activator="parent" location="top">
                              {{ $t('uploadIcon') }}
                            </v-tooltip>
                        </v-btn>
                      </td>
                      <td class="table-cell preview-cell">
                        <div class="image-preview">
                          <div
                            class="preview-avatar"
                          >
                            <img
                              v-if="item.imageURL && item.imageURL !== ''"
                              :src="item.imageURL"
                              alt="Preview"
                            />
                            <v-img v-else :src="images.iconpreviewImg"></v-img>
                        </div>
                        </div>
                      </td>
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :id="'button-deleterowmodel-popupadd-modelshortcut-commands-' + index"
                            :disabled="index == 0 && Shortcutmenu.listShortcuts.length == 1"
                            icon
                            size="small"
                            color="error"
                            variant="text"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_ShortcutMenu(index)"
                          >
                            <v-icon size="30">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              {{ $t('removeCommand') }}
                            </v-tooltip>
                          </v-btn>
                          
                          <v-btn
                            :id="'button-addrowmodel-popupadd-modelshortcut-commands-' + index"
                            icon
                            size="small"
                            color="success"
                            :variant="Adddialog ? 'flat' : 'text'"
                            class="actionbtns addbtn"
                            @click="Plus_ShortcutMenu(index)"
                          >
                            <v-icon size="30">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              {{ $t('addCommand') }}
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </div>
          <!-- Hidden file input -->
          <input
            id="inputfileShortcutMenu-edit"
            :aria-label="$t('uploadFile')"
            ref="bindFileNameShortcutMenu"
            type="file"
            @change="ShortcutMenuIcon"
            style="display: none"
            accept="image/png,image/jpeg"
          />
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions"> 
            <div class="actions-right">
              <v-btn
                variant="outlined"
                @click="shortcutMenuDialog = false"
                class="dialog-action-btn cancel-btn"
              >
                {{ $t("cancel") }}
              </v-btn>

              <v-btn
                :id="Adddialog ? 'button-save-popupadd-modelshortcut-commands' : 'button-save-popupedit-modelshortcut-commands'"
                variant="elevated"
                @click="Save"
                :class="['dialog-action-btn', Adddialog ? 'save-btn-add' : 'save-btn-edit']"
                :loading="dialog"
              >
              <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
                {{ $t("save") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="Detaildialog" max-width="400px">
      <v-card>
        <v-card-title
          class="text-h5 grey lighten-2"
          style="margin-bottom: 1rem; position: sticky; top: 0px; z-index: 1"
        >
          {{ $t("modelName") }}
        </v-card-title>
        <v-card-text v-for="item in TempModel" :key="item.id">
          <v-row>
            <v-col cols="10" sm="10" md="10">
              <span style="margin-right: 1rem">{{ item.name }}</span>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <v-btn
                id="botton-view-popupview-modelshortcut-commands"
                icon
                v-bind="attrs"
                @click="View(item)"
              >
                <v-icon att>mdi-eye</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('deleteConfirmation') }}</span>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            {{ $t('_confirmDeleteShortcutMenu') }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import basicInfo from "@/assets/images/basicinfo.png";
import chatInfo from "@/assets/images/chat.png";
import saveImg from '@/assets/images/savecard.png';
import iconcolImg from '@/assets/images/iconcol.png';
import iconpreviewImg from '@/assets/images/iconpreview.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
import InfoTooltip from "@/components/InfoTooltip.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import groupCrudCommonMixin from "@/mixins/groupCrudCommonMixin.js";
import quickGroupSourceMixin from "@/mixins/quickGroupSourceMixin.js";
import imageUploadHelpersMixin from "@/mixins/imageUploadHelpersMixin.js";
export default {
  name: "ModelShortcutMenu",
  components: { InfoTooltip, LoadingOverlay },
  mixins: [checkPermissionTwo, groupCrudCommonMixin, quickGroupSourceMixin, imageUploadHelpersMixin],
  inject : ['FontColorTitle','SubNavbarBackGround'],
  data: () => ({
    indexImportFile: null,
    uploadInputElementId: "inputfileShortcutMenu-edit",

    importData: null,

    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDGPTModel: [],
    headers_version_history: [],
    dialog_delete: false,
    deleteItem: null,
    searchName: "",
    isSearch: false,
    isFirst: true,
    menus: [],
    QuickGroup: [],
    quickReplyType: ["postback", "message"],
    images: {
      edit: editImg,
      delete: deleteImg,
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      basicInfo: basicInfo,
      chatInfo: chatInfo,
      saveImg: saveImg,
      iconcolImg: iconcolImg,
      iconpreviewImg: iconpreviewImg,
      deleteIcon: deleteIcon,
    },
    Shortcutmenu: {
      shortcutMenuGroupID: null,
      groupName: null,
      listShortcuts: [
        {
          id: 0,
          nameDisplay: null,
          command: null,
          imageURL: null,
        },
      ],
    },
    importDialog: false,
    TempModel: [],
    dialog_replace: false,
    replace_modelid: 0,
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    itemsPerPage_version: 5,
    sortBy: [],
    sortDesc: [],
  }),
  computed: {
    shortcutMenuDialog: {
      get() {
        return this.Adddialog || this.Editdialog;
      },
      set(value) {
        if (!value) {
          this.Adddialog = false;
          this.Editdialog = false;
        }
      },
    },
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          width: "95px",
        },
        {
          title: this.$t("shortcutMenu"),
          align: "left",
          sortable: true,
          value: "NameDisplay",
        },
        {
          title: this.$t("Command Name"),
          align: "left",
          sortable: false,
          value: "listCommand",
        },
        { title: this.$t("manage"), align: "center", sortable: false, width: "150px" },
      ];
    },
    areDialogsClosed() {
      return !this.Adddialog && !this.Editdialog;
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    filteredModels(index) {
      const selectedModelIds = new Set(
        this.Shortcutmenu.Model.filter((_, idx) => idx !== index).map(
          (model) => model.modelID
        )
      );

      return this.DDGPTModel.filter(
        (model) => !selectedModelIds.has(model.modelDisplayID)
      );
    },
    GetDDModelShortcutMenuCommand(id) {
      this.$call.GetDDModelShortcutMenuCommand(
        id,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            this.Shortcutmenu.listShortcuts = dataResponse.data;
            this.Shortcutmenu.shortcutMenuGroupID = id;
            this.loading = false;
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          this.loading = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      this.dialog = true;
      this.isSearch = true;
      this.options.page = 1;
      this.Get();
    },
    Get() {
      this.loadingTable = true;
      this.fetchServerTable(
        (temp, onSuccess, onError) => this.$call.GetTableShortcutMenuGroup(temp, onSuccess, onError),
        {
          onSuccess: () => {
            this.loadingTable = false;
            this.isSearch = false;
            this.isFirst = false;
            this.dialog = false;
          },
          onError: () => {
            this.loadingTable = false;
            this.isSearch = false;
            this.dialog = false;
          },
        }
      );
    },
    GetDDGPTModel() {
      this.dialog = true;
      this.$call.DDGPTModelIsPublish(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDGPTModel = dataResponse.data;
          } else {
            this.DDGPTModel = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      const id = this.deleteItem
      try {
          this.dialog_delete = false;
          this.dialog = true;

              this.$call.DeleteShortcutMenuGroup(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      title: this.$t("_successfullyDeleted"),
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    this.Editdialog = false;
                    this.Get();
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      this.Shortcutmenu.shortcutMenuGroupID = null;
      this.Shortcutmenu.groupName = null;
      this.Shortcutmenu.listShortcuts = [
        {
          id: 0,
          nameDisplay: null,
          command: null,
          imageURL: null,
        },
      ];
      // Shortcutmenu: {
      //   shortcutMenuGroupID: null,
      //   groupName: null,
      //   listShortcuts:[
      //     {
      //       id: 0,
      //       nameDisplay: null,
      //       command: null,
      //       imageURL: null,
      //     }
      //   ],
      // },
      this.Adddialog = true;
    },
    Edit(item) {
      this.Editdialog = true;
      //   Shortcutmenu: {
      //   shortcutMenuGroupID: null,
      //   groupName: null,
      //   listShortcuts:[
      //     {
      //       id: 0,
      //       nameDisplay: null,
      //       command: null,
      //       imageURL: null,
      //     }
      //   ],
      // },
      this.Shortcutmenu.shortcutMenuGroupID = item.shortcutMenuGroupID;
      this.Shortcutmenu.groupName = item.groupName;

      this.GetShortcutMenuByID(item.shortcutMenuGroupID);
    },
    async GetModelGroupAndShortcutMenu(_modelQuickGroupID) {
      try {
        this.dialog = true;
        await this.$call.GetModelGroupAndShortcutMenu(
          _modelQuickGroupID,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.Shortcutmenu.Model = dataResponse.data.groupList;
              this.Shortcutmenu.listShortcuts =
                dataResponse.data.quickReplyList;
            }

            if (this.Shortcutmenu.Model.length == 0) {
              this.Shortcutmenu.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  shortcutMenuGroupID: null,
                },
              ];
            }
            if (this.Shortcutmenu.listShortcuts.length == 0) {
              this.Shortcutmenu.listShortcuts = [
                {
                  id: 0,
                  label: null,
                  data: null,
                  type: null,
                  createDate: null,
                  createBy: null,
                  updateDate: null,
                  updateBy: null,
                  shortcutMenuGroupID: null,
                  imageURL: null,
                  activeFlag: true,
                },
              ];
            }
            this.dialog = false;
          },
          () => {
            this.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async GetShortcutMenuByID(id) {
      try {
        this.dialog = true;

        //   Shortcutmenu: {
        //   shortcutMenuGroupID: null,
        //   groupName: null,
        //   listShortcuts:[
        //     {
        //       id: 0,
        //       nameDisplay: null,
        //       command: null,
        //       imageURL: null,
        //     }
        //   ],
        // },
        await this.$call.GetShortcutMenuByID(
          id,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.Shortcutmenu = dataResponse.data.data;
            }
            this.dialog = false;
          },
          () => {
            this.dialog = false;
          }
        );
      } catch (error) { //NOSONAR
        /* no-op */
      }
    },
    async GetDDModelQuick(_modelQuickGroupID) {
      try {
        this.dialog = true;
        await this.$call.GetDDModelQuick(
          { shortcutMenuGroupID: _modelQuickGroupID },
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              if (
                this.Shortcutmenu.Model.length == 1 &&
                this.Shortcutmenu.Model[0].modelID == null &&
                this.Shortcutmenu.Model[0].shortcutMenuGroupID == null &&
                this.Shortcutmenu.Model[0].name == ""
              ) {
                this.Shortcutmenu.Model = dataResponse.data;
              } else {
                let tempGroup = this.Shortcutmenu.Model;
                this.Shortcutmenu.Model = this.Shortcutmenu.Model.concat(
                  dataResponse.data
                );
                if (this.RedundantCheck(this.Shortcutmenu.Model)) {
                  this.dialog = false;
                  alert(this.$t("_noDuplicatedModels"));
                  this.Shortcutmenu.Model = tempGroup;
                  this.importDialog = false;
                  return;
                }
              }
            }

            if (
              this.Shortcutmenu.Model.length == 0 &&
              dataResponse.data.length
            ) {
              this.Shortcutmenu.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  shortcutMenuGroupID: null,
                },
              ];
            }

            this.dialog = false;
          },
          () => {
            this.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Clear() {
      this.Shortcutmenu.shortcutMenuGroupID = null;
      this.Shortcutmenu.listShortcuts = null;
      this.Shortcutmenu.Name = null;
      this.Shortcutmenu.Model = null;
      this.Shortcutmenu.isAllModel = false;
      this.Editdialog = false;
      this.Adddialog = false;
    },
    async Save() {
      try {
        // Shortcutmenu: {
        //   shortcutMenuGroupID: null,
        //   groupName: null,
        //   listShortcuts:[
        //     {
        //       id: 0,
        //       nameDisplay: null,
        //       command: null,
        //       imageURL: null,
        //     }
        //   ],
        // },Shortcutmenu.groupName
        if (
          this.Shortcutmenu.groupName == "" ||
          this.Shortcutmenu.groupName == null
        ) {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("warning"),
            text: this.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        if (
          this.Shortcutmenu.listShortcuts.some(
            (e) =>
              !e.command ||
              e.command.trim() === "" ||
              !e.nameDisplay ||
              e.nameDisplay.trim() === ""
          )
        ) {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("_pleaseFillRequiredFields"),
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
        this.dialog = true;
        if (this.Adddialog) {
          await this.$call.CreateShortcutMenuGroup(
            this.Shortcutmenu,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  title: this.$t("_shortcutMenuCreated") + dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                  backdrop: false,
                  position: 'top',
                  customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
                });
                this.totalTable = this.totalTable + 1;
                this.Get();
                this.Adddialog = false;
              } else if (dataResponse.status == 3) {
                this.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        } else if (this.Editdialog) {
          await this.$call.UpdateShortcutMenuGroup(
            this.Shortcutmenu,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  title: "✔ " + dataResponse.message + this.$t("_updatedSuffix"),
                  showConfirmButton: false,
                  timer: 3000,
                  backdrop: false,
                  position: 'top',
                  customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
                });
                this.Get();
                this.Editdialog = false;
              } else if (dataResponse.status == 3) {
                this.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    Plus_ModelQuick(index) {
      this.Shortcutmenu.Model.splice(index + 1, 0, {
        modelQuickID: null,
        name: "",
        modelID: null,
        shortcutMenuGroupID: null,
      });
    },
    Minus_ModelQuick(index) {
      this.Shortcutmenu.Model.splice(index, 1);
    },
    Plus_ShortcutMenu(index) {

      // Shortcutmenu: {
      //   shortcutMenuGroupID: null,
      //   groupName: null,
      //   listShortcuts:[
      //     {
      //       id: 0,
      //       nameDisplay: null,
      //       command: null,
      //       imageURL: null,
      //     }
      //   ],
      // },
      this.Shortcutmenu.listShortcuts.splice(index + 1, 0, {
        id: 0,
        nameDisplay: null,
        command: null,
        imageURL: null,
      });
    },
    Minus_ShortcutMenu(index) {
      this.Shortcutmenu.listShortcuts.splice(index, 1);
    },

    Click_FileButtonShortcutMenu(_indexImportFile) {
      this.clickUploadFileButton(_indexImportFile);
    },

    ShortcutMenuIcon(e_para) {
      try {
        this.dialog = true;
        const file = this.getSelectedUploadFile(e_para);

        if (!file) {
          this.dialog = false;
          this.showUploadError("Something went wrong!");
          return;
        }

        if (!this.isSupportedUploadImage(file) || !this.hasUploadFileExtension(file)) {
          this.clearUploadError(this.$t("_onlyJpegPngFiles"));
          return;
        }

        this.loadUploadImage(file, (dataurl) => {
          this.Shortcutmenu.listShortcuts[this.indexImportFile].imageURL = dataurl;
          this.Shortcutmenu.listShortcuts[this.indexImportFile].imgName = file.name;
          this.resetUploadFileInput();
          this.dialog = false;
        });
      } catch {
        this.clearUploadError(this.$t("_somethingWentWrong"));
      }
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
#tableListPop_Id {
  border-collapse: collapse;
}

#tableListPop_Id td,
th {
  border-bottom: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

#tableListPop_Id tbody {
  height: 100%;
  overflow: auto;
}

.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
/* Modern Dialog Styles */
.modern-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}

/* Dialog Header */

/* Dialog Content */
.dialog-content {
  padding: 32px !important;
  max-height: 70vh;
  overflow-y: auto;
}

.form-container {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #C9C9C9;
}

.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  gap: 8px;
}
.section-header :deep(.v-img) {
  flex-shrink: 0; /* Prevent image from shrinking */
  margin: 0 !important; /* Remove any default margins */
}
.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  color: #171717;
  letter-spacing: 0.025em;
  line-height: 1;
  gap: 8px;
}

.count-chip {
  background: #e9f5fe !important;
  color: #1565c0 !important;
  font-weight: 600;
}

/* Input Styling */
.input-wrapper {
  margin-bottom: 20px;
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
  gap: 4px;
}

.required-asterisk {
  color: #d32f2f;
  font-weight: 700;
}

.help-icon {
  cursor: help;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.help-icon:hover {
  opacity: 1;
  color: #1976d2 !important;
  transform: scale(1.1);
}

.modern-input :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);
}

/* Table Styling */
.table-container {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
}

.modern-table {
  background: white;
}

.table-header {
  background: #FFF2F2;
  color: #171717 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: 16px 12px !important;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.table-header.actions-col {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}
.table-header.number-col {
  width: 60px !important;
  min-width: 60px !important;
  max-width: 60px !important;
}

.table-header.label-col {
  width: 200px !important;
  min-width: 200px !important;
}
.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-row:hover {
  background: rgba(25, 118, 210, 0.02);
}

.table-cell {
  padding: 12px !important;
  vertical-align: middle;
}

.number-cell {
  text-align: center;
  font-weight: 600;
  color: #666;
}

.upload-cell,
.preview-cell {
  text-align: center;
}

.actions-cell {
  text-align: center;
}

/* Table Components */
.table-input :deep(.v-field) {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.table-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.upload-btn {
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
  white-space: nowrap;
  min-width: auto;
}

.image-preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-avatar {
  border: 2px solid #C9C9C9;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 12px;
  width: 50px;
  height: 50px;
  margin: auto;
}

.preview-avatar.has-image {
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

.preview-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

/* Info Messages */
.info-message {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #edf7fe;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 0.875rem;
  color: #1565c0;
  margin-top: 16px;
}

/* Dialog Actions */

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 900px) {
  .dialog-header {
    padding: 20px 24px !important;
  }
  
  .dialog-content {
    padding: 24px !important;
  }
  
  .form-container {
    padding: 20px;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .modern-table {
    min-width: 800px;
  }
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  .modern-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
}

/* Add Model Section */
.add-model-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  transition: all 0.3s ease;
}

.add-model-btn {
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 160px;
  height: 44px;
  border: 2px solid #4caf50 !important;
}

.add-model-btn:hover {
  background: #2e7d32 !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.3) !important;
}
.summary-chip {
  border-radius: 40px;
  background: #ebeefa!important;  
  color: #3859D0 !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.actionbtns{
  background: transparent!important;

}
.addbtn{
  color: #2ABF56!important;
}
.removebtns{
  color: #C30000!important;
  background: white!important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
</style>
